// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16_nz","footer":"styles_footer__16goZ","passCodeTooltip":"styles_passCodeTooltip__10zUB"};